import { Injectable } from '@angular/core';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';

@Injectable()
export class ExcelGeneratorService {

  constructor() { }

  exportData(listObject: any,  ColumnsMatrix: any[], fileName: string) {
    let rows: any[] = [];
    let headers: any[] = []; 
    listObject.forEach(function (_itemRow) {
        let r = {};
        ColumnsMatrix.forEach(function (_itemHeader) { 
            let columnname =  _itemHeader.DataColumn;
            if ((columnname == 'REPORT_HOUR') && (fileName == 'Hourly Orders'))
            {
                r[columnname] = (_itemRow[columnname] == null) ? "" : "'" + String(_itemRow[columnname]);
            }
            else
            {
                r[columnname] = (_itemRow[columnname] == null) ? "" : _itemRow[columnname];
            }
        }); 
        rows.push(r);
    });
    //console.log(rows);
    ColumnsMatrix.forEach(function (_itemHeader) {  
        headers.push( _itemHeader.DisplayColumn);
    });
    const options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: true,
        headers: headers,
        showTitle: false,
        title: fileName,
        useBom: true,
    };
    new Angular2Csv(rows, fileName, options);
}
}



// WEBPACK FOOTER //
// ./src/app/services/excel-generator.service.ts